import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageDynamic from './LegalPageDynamic.jsx';

const PrivacyPolicyFallback = ({ backTo = '/', backLabel = 'トップに戻る', embedded = false }) => {
  const currentYear = new Date().getFullYear();
  const lastUpdated = '2026年2月3日';
  const pageClassName = embedded ? 'hub-legal-page hub-legal-page--embedded' : 'hub-legal-page';

  return (
    <div className={pageClassName}>
      <div className="hub-legal-container">
        <div className="hub-legal-header">
          <Link to={backTo} className="hub-legal-back">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: 20, height: 20 }}>
              <line x1="19" y1="12" x2="5" y2="12"/>
              <polyline points="12 19 5 12 12 5"/>
            </svg>
            {backLabel}
          </Link>
          <h1>プライバシーポリシー</h1>
          <p className="hub-legal-updated">最終更新日: {lastUpdated}</p>
        </div>

        <div className="hub-legal-content">
          <section>
            <h2>1. はじめに</h2>
            <p>
              株式会社ConvergePartners（以下「当社」といいます）は、Synapse Platform および Synapseシリーズ（以下「本サービス」といいます）の提供にあたり、
              お客様の個人情報の保護を重要な責務と認識し、以下のとおりプライバシーポリシーを定めます。
            </p>
          </section>

          <section>
            <h2>2. 収集する情報</h2>
            <p>当社は、本サービスの提供にあたり、以下の情報を収集することがあります。</p>
            <h3>2.1 お客様から直接提供いただく情報</h3>
            <ul>
              <li>氏名、表示名</li>
              <li>メールアドレス</li>
              <li>電話番号</li>
              <li>クリニック名、住所、郵便番号</li>
              <li>ログイン情報（ユーザーID、パスワード）</li>
              <li>お支払い情報（クレジットカード情報等）</li>
            </ul>
            <h3>2.2 自動的に収集される情報</h3>
            <ul>
              <li>アクセスログ（IPアドレス、アクセス日時、ブラウザ情報等）</li>
              <li>利用状況に関する情報</li>
              <li>端末情報</li>
              <li>Cookie情報</li>
            </ul>
          </section>

          <section><h2>3. 情報の利用目的</h2><p>収集した情報は、サービスの提供・維持・改善等の目的で利用します。</p></section>
          <section><h2>4. 情報の第三者提供</h2><p>法令に基づく場合等を除き、個人情報を第三者に提供することはありません。</p></section>
          <section><h2>5. 情報の安全管理</h2><p>個人情報の漏洩防止その他の安全管理のために適切な措置を講じます。</p></section>
          <section><h2>6. Cookieの使用</h2><p>サービス品質の向上のためCookieを使用しています。</p></section>
          <section><h2>7. お客様の権利</h2><p>お客様は個人情報の開示・訂正・削除・利用停止を求める権利を有します。</p></section>
          <section><h2>8. 個人情報の保存期間</h2><p>利用目的に必要な期間、個人情報を保存します。</p></section>
          <section><h2>9. 未成年者の個人情報</h2><p>本サービスは原則18歳以上の方を対象としています。</p></section>
          <section><h2>10. プライバシーポリシーの変更</h2><p>法令の改正等に応じて変更することがあります。</p></section>
          <section>
            <h2>11. お問い合わせ</h2>
            <p>本プライバシーポリシーに関するお問い合わせは、下記までご連絡ください。</p>
            <div className="hub-legal-contact">
              <p><strong>株式会社ConvergePartners</strong></p>
              <p>ウェブサイト：<a href="https://www.converge-p.co.jp" target="_blank" rel="noopener noreferrer">https://www.converge-p.co.jp</a></p>
            </div>
          </section>
        </div>

        <div className="hub-legal-footer">
          <p>&copy; {currentYear} Synapse by ConvergePartners Inc.</p>
        </div>
      </div>
    </div>
  );
};

const PrivacyPolicyPage = ({
  backTo = '/',
  backLabel = 'トップに戻る',
  embedded = false,
} = {}) => (
  <LegalPageDynamic
    docType="privacy"
    fallbackTitle="プライバシーポリシー"
    backTo={backTo}
    backLabel={backLabel}
    embedded={embedded}
    fallbackContent={
      <PrivacyPolicyFallback backTo={backTo} backLabel={backLabel} embedded={embedded} />
    }
  />
);

export default PrivacyPolicyPage;
